var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "error_icon_svg__st0",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#F54250"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6 3h2v4H6zM6 9h2v2H6z"
  })));
}
export default __webpack_public_path__ + "error_icon.bba95512.svg";
export { SvgErrorIcon as ReactComponent };